import { useContext, useState } from 'react';
import { MapContext } from '../../context/MapContext';
import { IconButton, Slider, Tooltip } from '@mui/material';
import { householdLayers } from '../content/layer';
import InfoIcon from '@mui/icons-material/Info';

export default function GridLegend() {
	const {
		mode,
		gridOpacity,
		setGridOpacity,
		selectPoi,
		agglomerate,
		setAgglomerate,
		location,
		setLocation,
		industry,
		setIndustry,
	} = useContext(MapContext);

	const match = {
		agglomerate: {
			isChecked: setAgglomerate,
			layer: householdLayers.sphAgglomerateLayer,
		},
		location: {
			isChecked: setLocation,
			layer: householdLayers.sphLocationLayer,
		},
		industry: {
			isChecked: setIndustry,
			layer: householdLayers.sphIdsLayer,
		},
	};

	const handleOption = (e) => {
		const value = e.target.value;
		match[value].isChecked(e.target.checked);
		match[value].layer.setVisible(e.target.checked);
	};

	const handleGridOpacity = (e, newValue) => {
		if (typeof newValue === 'number') {
			setGridOpacity(newValue);
			householdLayers.sphAgglomerateLayer.setOpacity(newValue);
			householdLayers.sphLocationLayer.setOpacity(newValue);
			householdLayers.sphIdsLayer.setOpacity(newValue);
		}
	};

	return (
		<div className="resultLegend">
			<div className="header">분석결과</div>
			<div className="modalBody">
				<label htmlFor="" className="chk_box tit">
					<input
						type="checkbox"
						name=""
						id=""
						value="agglomerate"
						onChange={handleOption}
						checked={agglomerate}
					/>
					<p className="textline">
						<span className="pointcolor green"></span>
						집적지 분석 결과 격자
						<Tooltip
							title="분석 격자를 클릭하면 SGIS 인구데이터(거주인구 수, 연령별 인구수)를 확인 할 수 있습니다."
							arrow
							placement="right"
						>
							<IconButton size="small" className="infoTooltipBtn">
								<InfoIcon className="infoTooltipIcon"></InfoIcon>
							</IconButton>
						</Tooltip>
					</p>
				</label>
				{(mode === 'location' && householdLayers.sphLocationLayer.getSource().getFeatures().length > 0) && (
					<>
						<label htmlFor="" className="chk_box tit">
							<input
								type="checkbox"
								name=""
								id=""
								value="location"
								onChange={handleOption}
								checked={location}
							/>
							<p className="textline">
								<span className="pointcolor red"></span>
								입지속성 분석 결과 격자
							</p>
						</label>
						{(selectPoi === 'sph_grid_ids' && householdLayers.sphIdsLayer.getSource().getFeatures().length > 0) && (
							<label htmlFor="" className="chk_box tit">
								<input
									type="checkbox"
									name=""
									id=""
									value="industry"
									onChange={handleOption}
									checked={industry}
								/>
								<p className="textline">
									<span className="pointcolor redblack"></span>
									산업단지에 입지한 격자
									<Tooltip
										title="‘산업단지’의 경우 단지 안에 포함되어 있는 격자를 확인 할 수  있습니다."
										arrow
										placement="right"
									>
										<IconButton size="small" className="infoTooltipBtn">
											<InfoIcon className="infoTooltipIcon"></InfoIcon>
										</IconButton>
									</Tooltip>
								</p>
							</label>
						)}
					</>
				)}
				<span className="line"></span>
				<div className="opacityProgBar">
					<p className="tit">격자 불투명도</p>
					<Slider
						value={gridOpacity}
						min={0}
						max={1}
						step={0.1}
						onChange={handleGridOpacity}
						valueLabelDisplay="auto"
					/>
				</div>
			</div>
		</div>
	);
}
